import React from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Form,
  Col,
  InputNumber,
  Button,
  Spin,
  message,
} from 'antd';
import { aoObjectOf, aoIndexOf } from 'util/ArrayUtils.jsx';
import _ from 'lodash';

const FormItem = Form.Item;
const Panel = Collapse.Panel;

class RegistroAbsences extends React.Component {

  componentDidMount() {
    this.props.form.validateFields();
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const absencesToWS = _.cloneDeep(this.props.registryAbsences);
    let idx;
    this.props.form.validateFields((err, dataForm) => {
      if (err) {
        return;
      }
      console.log('recuperati dati dalla form', dataForm);
      idx = aoIndexOf(absencesToWS, 'LSA', 'codice');
      if (idx > -1) {
        absencesToWS[idx].ore = parseFloat(dataForm.salute, 10);
      } else {
        const newAbsence = {
          codice: 'LSA',
          ore: parseFloat(dataForm.salute, 10),
        };
        absencesToWS.push(newAbsence);
      }
      idx = aoIndexOf(absencesToWS, 'LUF', 'codice');
      if (idx > -1) {
        absencesToWS[idx].ore = parseFloat(dataForm.ufficio, 10);
      } else {
        const newAbsence = {
          codice: 'LUF',
          ore: parseFloat(dataForm.ufficio, 10),
        };
        absencesToWS.push(newAbsence);
      }
      idx = aoIndexOf(absencesToWS, 'LAL', 'codice');
      if (idx > -1) {
        absencesToWS[idx].ore = parseFloat(dataForm.altro, 10);
      } else {
        const newAbsence = {
          codice: 'LAL',
          ore: parseFloat(dataForm.altro, 10),
        };
        absencesToWS.push(newAbsence);
      }
      console.log('array assenze da passare al WS:', absencesToWS);
      this.props.onUpdateAbsences(this.props.registryInfo.idRegistro,
                                  absencesToWS)
      .then((response) => {
        console.log('debug 8:', response);
        // TODO: settare nuove notifiche con antd
        if (response.error) {
          return false;
        }
        message.success('Modifica salvata con successo.');
        return true;
      });
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    console.log('assenze registrate:', this.props.registryAbsences);
    console.log('ore assegnate:', this.props.registryInfo.totaliAssegnate);
    const disabled = (this.props.registryInfo.stato === 'N' ? false : true);
    let hoursLAL;
    let hoursLUF;
    let hoursLSA;
    if (this.props.registryAbsences) {
      hoursLAL = aoObjectOf(this.props.registryAbsences, 'LAL', 'codice').ore;
      hoursLUF = aoObjectOf(this.props.registryAbsences, 'LUF', 'codice').ore;
      hoursLSA = aoObjectOf(this.props.registryAbsences, 'LSA', 'codice').ore;
    }
    return (
      <Collapse
        className="box box-solid box-unimi collapsed-box vmg10"
      >
        <Panel header="Ore non svolte" key="oreGiustificate">
          <Spin
            spinning={this.props.isEditing}
            tip="Caricamento..."
          >
            <div>
              Ore di attività non tenute per motivi di:
              <Form 
                layout="inline"
                onSubmit={this.handleSubmit}
                className="simple-form"
              >
                <Col span={7} key="salute">
                  <FormItem label={"SALUTE"}>
                    {getFieldDecorator('salute', { initialValue: hoursLSA })(
                      <InputNumber min={0} step={0.5} disabled={disabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={7} key="ufficio">
                  <FormItem label={"IMPEGNI DI UFFICIO"}>
                    {getFieldDecorator('ufficio', { initialValue: hoursLUF })(
                      <InputNumber min={0} step={0.5} disabled={disabled} />
                    )}
                  </FormItem>
                </Col>  
                <Col span={7} key="altro">
                  <FormItem label={"ALTRO"}>
                    {getFieldDecorator('altro', { initialValue: hoursLAL })(
                      <InputNumber min={0} step={0.5} disabled={disabled} />
                    )}
                  </FormItem>
                </Col>  
                <Col span={3} className="to-right" key="button">
                <FormItem>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={disabled}
                    >
                      Salva
                    </Button>
                  </FormItem>
                </Col>    
              </Form>
            </div>
          </Spin>
        </Panel>
      </Collapse>
    );
  }
}

RegistroAbsences.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  registryAbsences: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUpdateAbsences: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

const WrappedRegistroAbsences = Form.create()(RegistroAbsences);

export default WrappedRegistroAbsences;
